export default "__VITE_ASSET__b940c1fa__"